export const requiredFieldValidationMessage = 'Please complete this field'
export const numberValidationMessage = 'Please enter numbers only'
export const numberSelectValidationMessage = 'Please select'
